export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14453.dfc697e4.jpg";